import Request from './request';

import consts from "@/consts.js";


async function fetch(data) {
    return Request('get', "api/account-ads/index", data);
}

async function fetchOne(id) {
    return Request('get', "api/account-ads/view/" + id);
}

async function save(id,data){
    if(id){
        return Request('patch','api/account-ads/edit?id=' + id,data);
    }else{
        return Request('patch','api/account-ads/add',data)
    }
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; // 获取全部
    data.itemsPerPage = consts.limitAll // 获取全部
    // data.fieldFilter = ["id", "shop_code", "shop_name"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

async function pushShop(data){
    return Request('patch',"api/account-ads/pushShop/",data)
} 


async function del(id){
    return Request('delete',"api/account-ads/del/" + id )
}

export default {
    fetch, 
    fetchOne,
    save,
    fetchAllForSelect,
    pushShop,
    del
};